import { jsx as _jsx } from "react/jsx-runtime";
import 'core-js/stable';
import 'regenerator-runtime/runtime';
import { render } from 'react-dom';
import { StylesAsDataAttributes } from 'substyle-glamor';
import Demo from './Demo';
render(_jsx(StylesAsDataAttributes, { children: _jsx(Demo, {}) }), document.querySelector('#demo'));
